<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Chyba přihlášení</div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'throttle-dialog'">
        <p>
            <span>Nespěchejte! Přihlásit se s telefonním číslem</span>
            <strong>&nbsp;{{ data.country }}&nbsp;{{ data.phone }}&nbsp;</strong>
            <span>je možné jen jednou za minutu. Prosím, počkejte ještě</span>
            <strong>&nbsp;{{ seconds }}&nbsp;{{ seconds | secondsPipe }}</strong>
            <span>.</span>
        </p>
    </div>

    <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-around">
        <button
            type="button"
            mat-button
            class="btn btn-sm primary-transparent"
            [attr.data-testid]="'throttle-dialog-button-cancel'"
            (click)="closeDialog()">
            Zrušit
        </button>

        <button
            class="btn btn-lg orange info-text-dialog-button"
            type="button"
            mat-raised-button
            [disabled]="seconds > 0"
            [attr.data-testid]="'throttle-dialog-button-ok'"
            (click)="submitDialog()"
            [innerHTML]="'Zkusit znovu' + (seconds ? ' (' + seconds + ' s)' : '')"></button>
    </div>
</mat-dialog-content>
